import React from "react"
import NavigateToTransformLink from "./navigate_to_transform_link"
import PreviewSection from "./preview_section"
import styled from "@emotion/styled"

export default class PreviewSections extends React.PureComponent {
  render() {
    const transformsWithPreviews = this.props.transforms.filter((t) => {return t.hasPreviewImages});
    return (
      <>
        <PreviewHead className="section">
          <div className="section_inner">
            <h3>
              {`${this.props.data.preview.string} `}
              { transformsWithPreviews.map((transform, i) => {
                return <NavigateToTransformLink key={`preview_link_${i}`} transform={transform} />
              })}
            </h3>
            <p>See how these styles look on apps like Facebook, Twitter, SMS; and on Mac, Windows, iPhone and Android devices.</p>
          </div>
        </PreviewHead>
        <Sections>
          { transformsWithPreviews.map((t, i) => {
            return <PreviewSection key={`preview_section_${i}`} transform={t} {...this.props} />
          })}
        </Sections>
      </>
    )
  }
}

const PreviewHead = styled("div")`
background: rgb(96, 184, 195)
`
const Sections = styled("div")`
.section:nth-of-type(even) { background: #6DBDC9; }
`
